import Text from "@src/lib/ui/Text";
import Widget from "@src/features/home/Widget";
import { Skeleton } from "@src/lib/ui/Skeleton";
import { gql } from "@apollo/client";
import {
  useNotInvitedUsersWidgetHrisEmployeesQuery,
  useNotInvitedUsersWidgetNotInvitedHrisEmployeesQuery,
} from "@src/features/home/NotInvitedUsersWidget.generated";
import NotInvitedUsersSheet from "@src/features/home/NotInvitedUsersSheet";
import QrCodeIcon from "@src/lib/icons/18px/qr-code";

const UsersNotInvitedWidget: React.FC = () => {
  const { data, loading } = useNotInvitedUsersWidgetHrisEmployeesQuery();
  const hasHrisEmployees =
    data?.HrisEmployees.totalCount && data?.HrisEmployees.totalCount > 0;
  const {
    data: notInvitedHrisEmployeesData,
    loading: notInvitedHrisEmployeesLoading,
  } = useNotInvitedUsersWidgetNotInvitedHrisEmployeesQuery();
  const notInvitedHrisEmployeesCount =
    notInvitedHrisEmployeesData?.NotInvitedHrisEmployees.totalCount || 0;
  if (!hasHrisEmployees) return null;
  return (
    <Widget
      title="Not Invited"
      className="flex-1 self-stretch shadow-none"
      Icon={QrCodeIcon}
    >
      {loading || notInvitedHrisEmployeesLoading ? (
        <Skeleton className="h-6 w-10 rounded-md" />
      ) : (
        <div className="flex flex-row items-center gap-1 align-middle">
          <NotInvitedUsersSheet>
            <Text
              variant="display-bold"
              className="cursor-pointer hover:underline"
            >
              {notInvitedHrisEmployeesCount}
            </Text>
          </NotInvitedUsersSheet>
        </div>
      )}
    </Widget>
  );
};

gql`
  query NotInvitedUsersWidgetHrisEmployees {
    HrisEmployees(input: {}) {
      totalCount
    }
  }
  query NotInvitedUsersWidgetNotInvitedHrisEmployees {
    NotInvitedHrisEmployees: HrisEmployees(
      input: { filters: { inviteStatus: { value: false } } }
    ) {
      totalCount
    }
  }
`;

export default UsersNotInvitedWidget;
